import UgcSelection from './UgcSelection.container';

export default UgcSelection;



// WEBPACK FOOTER //
// ./src/ui/interaction/children/ugcvisualization/index.js